import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  connect() {
    this.interval = window.setInterval(() => {
      Turbo.visit(window.location.href, { action: "replace" })
    }, 3000)
  }

  disconnect() {
    window.clearInterval(this.interval)
  }
}
